module.exports = __webpack_public_path__ + "img/apple.91c7deee.png";